import localeData from 'react-intl/locale-data/zh'

const messages = {
  'topBar.typeToSearch': '搜索...',
  'topBar.profileMenu.hello': '你好',
  'topBar.profileMenu.billingPlan': '结算计划',
  'topBar.profileMenu.role': '角色',
  'topBar.profileMenu.email': '电子邮件',
  'topBar.profileMenu.phone': '电话',
  'topBar.profileMenu.editProfile': '编辑个人资料',
  'topBar.profileMenu.logout': '登出',
}

export default {
  locale: 'zh-CH',
  antdData: null,
  localeData,
  messages,
}
